import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Set from "@babel/runtime-corejs3/core-js/set";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
export const RESET_CLIENT_ACTIVITY = "RESET_CLIENT_ACTIVITY";
export const SET_CLIENT_ACTIVITY = "SET_CLIENT_ACTIVITY";
const mutations = {
  [RESET_CLIENT_ACTIVITY]: state => {
    state.clientActivity = {
      byId: {},
      allIds: []
    };
  },
  [SET_CLIENT_ACTIVITY]: (state, {
    clients
  }) => {
    state.clientActivity.byId = _objectSpread(_objectSpread({}, state.clientActivity.byId), clients.byId);
    state.clientActivity.allIds = [...new _Set([...state.clientActivity.allIds, ...clients.allIds])];
  }
};
export default mutations;